import api from "./api"; // instance axios
import { environnement } from "configs/environnement";
import { IRequestPasswordReset, IKeyAndPassword } from "models/church.types";

export const AuthService = {
  login: async (credentials: {
    username: string;
    password: string;
    rememberMe?: boolean;
  }) => {
    const response = await api.post("/authenticate", credentials);
    const jwt = response.data.id_token;

    if (jwt) {
      localStorage.setItem("authenticationToken", jwt);
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem("authenticationToken");
    window.location.href = "/auth/login"; // Redirection
  },
  /**
   * Envoi du mail de réinitialisation
   */
  requestPasswordReset: (data: IRequestPasswordReset) => {
    return api.post(`${environnement.baseURL}/users/reset-password/init`, data);
  },

  /**
   * Validation de la clé et enregistrement du nouveau mot de passe
   */
  finishPasswordReset: (data: IKeyAndPassword) => {
    return api.post(`${environnement.baseURL}/users/reset-password/finish`, data);
  },
};